import React from 'react'
import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import './styles/PolicyPage.css'
import HelmetTitle from "app/meta/HelmetTitle"

export default function PrivacyPage() {
  return (
    <div className="privacy-page policy-page">
      <HelmetTitle title="Privacy Policy" />
      <PageBanner
        title="Privacy Policy"
        subtitle="Read our privacy policy for information about how we collect and use your data."
      />
      <SiteGrid>
        <div className="page-content">
          <h1>Privacy Policy for Aphrodite</h1>
          <p>
            Aphrodite Clinic is committed to protecting your privacy. This privacy
            policy explains how we collect, use, and disclose information about you
            when you visit our website.
          </p>
          <h2>Information We Collect</h2>
          <p>
            We collect information about you when you visit our website, including your
            IP address, browser type, pages you visit, and other standard web log information.
            We may also collect information you provide to us through contact forms, email
            subscriptions, or other means.
          </p>
          <h2>Use of Information</h2>
          <p>
            We use the information we collect to improve our website, personalize your
            experience, and communicate with you. We may also use the information to send
            you marketing communications about our products and services, but you can opt
            out of these communications at any time.
          </p>
          <h2>Disclosure of Information</h2>
          <p>
            We may share your information with third-party service providers who help us
            operate our website and provide our products and services. We may also share
            your information when required by law or to protect our rights or the rights
            of others.
          </p>
          <h2>Cookies</h2>
          <p>
            We use cookies to improve your experience on our website. Cookies are small
            data files stored on your device that allow us to remember your preferences
            and actions. You can control cookies through your browser settings.
          </p>
          <h2>Security</h2>
          <p>
            We take reasonable measures to protect your information from unauthorized access,
            use, or disclosure. However, no data transmission over the internet or other
            network can be guaranteed to be 100% secure.
          </p>
          <h2>Updates to this Policy</h2>
          <p>
            We may update this privacy policy from time to time. We will post any updates on
            this page and notify you of any material changes by email.
          </p>
          <br /><br />
          <p>
            Contact us at <a href="mailto:info@aphrodite.com">info@aphrodite.com</a> with any
            questions or concerns regarding this privacy policy or the use of your personal
            information.
          </p>
        </div>
      </SiteGrid>
    </div >
  )
}
